import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class SmartOfferButtonPlace extends Cloneable {

    static NONE = new SmartOfferButtonPlace(0, "NONE");

    static _values = [
        this.NONE,
        new SmartOfferButtonPlace(2, "PANEL_BOTTOM"),
        new SmartOfferButtonPlace(3, "PANEL_LEFT"),
        new SmartOfferButtonPlace(4, "PANEL_RIGHT")
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, SmartOfferButtonPlace.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof SmartOfferButtonPlace) {
            return SmartOfferButtonPlace._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DEFAULT") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    equal(value) {
        if (value instanceof SmartOfferButtonPlace) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferButtonPlace());
        } else if (target instanceof SmartOfferButtonPlace) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferButtonPlace, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});